import type { ComponentProps } from 'react';

import Lock from '@/public/assets/svg/Icon/Lock.svg';

export const IconLock = ({ ...props }: ComponentProps<'svg'>) => {
  return <Lock {...props} />;
};
